import { IProject } from "@/interfaces/project.interface";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ProjectState {
  projects: Partial<IProject>[];
  selectedProject: Partial<IProject> | null;
}

const initialState: ProjectState = {
  projects: [],
  selectedProject: {},
};

const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    setSelectedProject: (state, action: PayloadAction<IProject>) => {
      state.selectedProject = action.payload;
    },
    setProjects: (state, action: PayloadAction<IProject[]>) => {
      state.projects = action.payload
    },
  },
});

export const { setSelectedProject, setProjects } = projectSlice.actions;
export default projectSlice.reducer;
